import React from 'react';

export default function AboutPage() {
  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">About Manifold Tournaments</h1>
        <p className="page-subtitle">Unofficial tournament platform for manifold.markets</p>
      </div>

      <div className="about-container">

        <div className="card">
          <h2 className="about-section-title">What is this?</h2>
          <p>
            An unofficial tournament platform for <a href="https://manifold.markets" target="_blank" rel="noopener noreferrer">
            Manifold Markets</a>. Anyone can bundle existing Manifold questions into a
            competition: the leaderboard ranks traders by their combined profit across the
            tournament's markets, and hosts can offer mana prizes for the top finishers.
          </p>
        </div>

        <div className="card">
          <h2 className="about-section-title">How to Participate</h2>
          <ol className="about-list">
            <li>Browse tournaments on the main page (filter by Active, Coming Up, or Finished)</li>
            <li>Open a tournament to see its markets, prizes, and live leaderboard</li>
            <li>Click any market to trade on Manifold — profit on tournament markets is your score</li>
            <li>Check back to watch your leaderboard position; when the tournament finishes, the top 3 are locked in as official winners</li>
          </ol>
          <p>
            There's no sign-up for open tournaments: if you trade on a tournament's markets with
            your Manifold account, you're on the leaderboard automatically. Tournaments marked
            "Invitational" only rank their listed participants — ask the host to add you.
          </p>
        </div>

        <div className="card">
          <h2 className="about-section-title">How to Host</h2>
          <ol className="about-list">
            <li>Click "Create Tournament" and pick a name and description</li>
            <li>Add markets by Manifold topic tags, hand-picked selections, or both (up to 100 markets)</li>
            <li>Optionally set mana prizes for 1st–3rd place and list yourself as a host</li>
            <li>Optionally list participants and mark the tournament invitational to restrict the leaderboard to them</li>
            <li>Choose an admin code — anyone with the code can edit or delete the tournament, so keep it safe</li>
            <li>When the competition ends, set the status to Finished: the current top 3 are recorded as the official winners</li>
          </ol>
          <p>
            Prize payouts happen on Manifold itself (e.g. via managrams) — this site tracks
            who won, not the transfer.
          </p>
        </div>

        <div className="card">
          <h2 className="about-section-title">Hall of Fame &amp; User Lookup</h2>
          <p>
            The <a href="/halloffame.html">Hall of Fame</a> ranks every
            tournament champion by titles won, and the{' '}
            <a href="/user.html">User Lookup</a> page shows any
            Manifold user's tournament record: podium finishes, prize winnings, and
            tournaments they've hosted.
          </p>
        </div>

        <div className="card">
          <h2 className="about-section-title">Fine Print</h2>
          <ul className="about-list">
            <li>Scores use Manifold's per-market profit numbers for each trader's overall position</li>
            <li>Leaderboards are computed live from the Manifold API and may lag a little</li>
            <li>This site is not affiliated with Manifold Markets</li>
          </ul>
        </div>

      </div>
    </div>
  );
}
